import OpenPopupLayout from '@/layout/OpenPopupLayout'
import OpenPopupAddressResult from '@/pages/open_popup/AddressResult'
import VirtualAccountKLNetPop from '@/pages/settle/popup/VirtualAccountKLNetPop.vue'
const routes = [
  {
    path: '/open-popup',
    component: OpenPopupLayout,
    children: [
      {
        path: 'address-result',
        component: OpenPopupAddressResult
      },
      {
        path: 'voc-pop',
        component: () => import('@/pages/trans/popup/BookingVOCPop')
      },
      {
        path: 'print-pop',
        component: () => import('@/pages/trans/popup/ContentPrintPop'),
        props: true
      },
      {
        path: 'notice-pop',
        component: () => import('@/pages/trans/popup/NoticePop'),
        props: true
      },
      {
        path: '/virtualAccount',
        component: () => import('@/pages/settle/popup/VirtualAccountKLNetPop'),
        props: true
      },
      {
        path: '/virtualAccount/complete',
        component: () => import('@/pages/settle/popup/VirtualAccountResult'),
        props: true
      },
      {
        path: '/virtualAccount/cancel',
        component: () => import('@/pages/settle/popup/VirtualAccountResult'),
        props: true
      }
    ]
  }
]

export default routes
